import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import {
  MatBadgeModule, MatCardModule,
  MatStepperModule, MatTableModule,
  MatInputModule, MatSelectModule,
  MatButtonModule, MatProgressBarModule,
  MatNativeDateModule, MatDatepickerModule,
  MatCheckboxModule, MatRadioModule,
  MatIconModule, MatDialogModule,
} from '@angular/material';
import {MatPaginatorModule} from '@angular/material/paginator';

@NgModule({
  imports: [
    CommonModule, MatDialogModule, MatPaginatorModule, MatIconModule,  MatRadioModule, MatCheckboxModule,
    MatBadgeModule, MatStepperModule, MatTableModule , MatProgressBarModule,
    MatInputModule, MatSelectModule, MatButtonModule, MatNativeDateModule, MatDatepickerModule
  ],
  exports: [
    MatCardModule, MatPaginatorModule, MatDialogModule, MatIconModule,  MatRadioModule, MatCheckboxModule,
     MatBadgeModule, MatStepperModule, MatTableModule, MatProgressBarModule,  MatInputModule, MatSelectModule,
      MatButtonModule, MatNativeDateModule, MatDatepickerModule
  ],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true }}
  ],
})
export class AppMaterialModule { }
